import { render, staticRenderFns } from "./GoodsCon.vue?vue&type=template&id=0f9c9590&scoped=true"
import script from "./GoodsCon.vue?vue&type=script&lang=js"
export * from "./GoodsCon.vue?vue&type=script&lang=js"
import style0 from "./GoodsCon.vue?vue&type=style&index=0&id=0f9c9590&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9c9590",
  null
  
)

export default component.exports